<template>
    <div dir="ltr">
        <count-down-digit :digit="hours[0]" />
        <count-down-digit :digit="hours[1]" />
        :
        <count-down-digit :digit="minutes[0]" />
        <count-down-digit :digit="minutes[1]" />
        :
        <count-down-digit :digit="seconds[0]" />
        <count-down-digit :digit="seconds[1]" />
    </div>
</template>

<script>
import CountDownDigit from './count-down-digit';

function pad (n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

export default {

    components: {
        CountDownDigit,
    },

    props: {
        timer: {
            type: Number,
            required: true,
        },
    },

    data () {
        return {
            localTimer: this.timer,
        };
    },

    computed: {
        seconds () {
            return pad(this.localTimer % 60, 2);
        },
        minutes () {
            return pad(Math.floor(this.localTimer / 60) % 60, 2);
        },
        hours () {
            return pad(Math.floor(this.localTimer / 60 / 60) % 60, 2);
        },
    },

    mounted () {
        const timerInterval = this.$setInterval(() => {
            if (this.localTimer > 0) this.localTimer--;
            else {
                clearInterval(timerInterval);
                this.$emit('hide');
            }
        }, 1000);
    },
};
</script>
